import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import React from "react";
import {MobileMenuItemContainerBox} from "../boxes/mobile-menu-item-container.box";
import {MobileMenuItemLinkBox} from "../boxes/mobile-menu-item-link.box";
import {AreaType} from "@sparkware/uc-sdk-core/lib/apps/app-enums";
import {AppIdentifiers} from "@sparkware/uc-sdk-core";
import { GenericSideMenuIconBox } from "../../side-menu-rework/side-menu-link/boxes/link/generic-side-menu-icon.box";

export class MobileHelpCenterMenuItemComponent extends OrbitComponent {

    private async _openHelpWidget(): Promise<void> {
        await this.services.appLauncher.openHelpWidget({
            businessCorrelationID: this.services.tools.getGuid(),
            channel: {
                area: AreaType.HamburgerMenu,
                element: AppIdentifiers.CRHelpCenter,
                source: AppIdentifiers.CasinoClient
            }
        });
    }

    private _mobileHelpButtonHandler = () => {
        if (this.services.configuration.servicesConfigs.AppLauncher.apps.CR_HELP_CENTER.enabled) {
            this._openHelpWidget();
            this.services.sideMenu.closeMobileMenu();
        } else {
            this.services.sideMenu.openHelp()
        }
    }

    private _renderText(): string {
        if (this.services.configuration.servicesConfigs.AppLauncher.apps.CR_HELP_CENTER.enabled) {
            return this.services.translation.translate("HELP_CENTER")
        } else {
            return this.services.translation.translate("HELP")
        }
    }

    render() {
        const HelpIcon = this.services.theme.currentTheme.icons.sideMenuHelp;
        return (
            <MobileMenuItemContainerBox className="cy-menu-item">
                <GenericSideMenuIconBox>
                    <HelpIcon size={2} />
                </GenericSideMenuIconBox>
                <MobileMenuItemLinkBox className="cy-help-mobile-link" onClick={this._mobileHelpButtonHandler}>
                    {this._renderText()}
                </MobileMenuItemLinkBox>
            </MobileMenuItemContainerBox>
        );
    }
}